<template>
  <div class="like_user">
    <div class="user_left" @click="goSuperLink('userview', dataInfo.uid)">
      <div class="user_box">
        <img :src="dataInfo.headpic" alt="" class="user_img">
        <img v-if="dataInfo.auth_icon" class="icon_vip" :src="dataInfo.auth_icon" alt="">
      </div>
      <div class="ml10 user_text_lang">
        <h3 class="fs_16 clr_black fw_bold text_over">{{ dataInfo.nick_name }}</h3>
        <p v-if="dataInfo.role==5" class="fs_12 clr_gray text_over">{{ dataInfo.brief }}</p>
        <p v-else class="fs_12 clr_gray text_over">{{ dataInfo.unit }} {{ dataInfo.duty }}</p>
      </div>
    </div>
    <span v-if="dataInfo.follow_status==0" class="like_btns bg_golden fs_12" @click="opnFollow('followAdd',1)">关注</span>
    <span v-else class="like_btns bg_gray1 fs_12" @click="opnFollow('followDel',0)">已关注</span>
  </div>
</template>
<script>
import '@/style/scss/bigEvent/index.scss'
import { superLink } from '@/utils'
import config from '@/config/config'

import { Toast } from 'vant'

import { ajaxHttp } from '@/api/api'
import utils from '@/utils/utils'
export default {
  name: 'JoinOpus',
  components: {
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    async opnFollow($url, $type) { // 关注
      if (!utils.is_mini()) { // 如果不是微信内
        this.goSuperLink('userview', this.dataInfo.uid); return false
      }
      const self = this
      const data = { follow_user_id: this.dataInfo.uid }
      Toast.loading({
        message: 'Loading...',
        forbidClick: true
      })
      const followRes = await ajaxHttp[$url](data)
      if (followRes.code === 1) {
        self.dataInfo.follow_status = $type
        Toast.clear()
        this.$forceUpdate()
      } else { Toast(followRes.message) }
    },
    goSuperLink($des, $skuid) {
      // JSON标准格式双引号，eslint默认单引号，冲突
      const data = `{
        "des": "${$des}", 
        "skuid": "${$skuid}",
        "link": "${config.webapplink}/${$des}?id=${$skuid}"
      }`
      return superLink(data)
    },
    goApp() {
      // const u = navigator.userAgent
      // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      // if (utils.is_weixn()) {
      //   if (!isAndroid) { // !isAndroid
      //     utils.goDown('H5', this.shareInfo.share_link)
      //   } else {
      //     this.guideShow = true
      //   }
      // } else {
      // const data = `{
      //   "des": "userview",
      //   "skuid": ${this.dataInfo.uid},
      //   "link": "${config.webapplink}/userview?id=${this.dataInfo.uid}"
      // }`
      // return superLink(data)
      // }
    }
  }
}
</script>
<style scoped>
.like_user{width: 359px !important;height: 72px;border-bottom: 0.5px solid #E5E5E5;padding: 0px !important;position: relative;}
.like_user:last-child{border-bottom: none;}
.user_left{position: absolute;left: 0;}
.like_user .like_btns{position: absolute;right: 16px;}
</style>
